
import { getInfo } from '@/api/index'
// 独立vuex模块 用户模块
const state = {
  accessedRoutes: [],
  roles: [],
  name: ''
}
// 同步操作
const mutations = {
  SET_ACCESSEDROUTES: (state, accessedRoutes) => {
    state.accessedRoutes = accessedRoutes
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
}
// 异步操作
const actions = {
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo().then(response => {
        const { data } = response
        if (!data) {
          reject('Verification failed, please Login again.')
        }
        const accessedRoutes = data.accessed_routes
        const { roles, name, permissions } = data.admin_info
        if (!roles || roles.length <= 0) {
          reject('getInfo: roles or permissions must be a non-null array!')
        }
        if (permissions && permissions.length > 0) {
          accessedRoutes.push({
            hidden: true,
            name: 'user-perimissions',
            path: 'user-perimissions',
            children: permissions
          })
        }
        commit('SET_ROLES', roles)
        commit('SET_NAME', name)
        commit('SET_ACCESSEDROUTES', accessedRoutes)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

}

export default {
  namespaced: true, // 开启命名空间模块
  state,
  mutations,
  actions,
}
